
<div style="display: flex; float: right;">
  <div>
    <button mat-button (click)="showData('add-user')"><mat-icon>add</mat-icon>Add User</button>
  </div>
  <div>
    <button mat-button (click)="showData('user-list')"><mat-icon>people</mat-icon> Users List</button>
  </div>
</div>

<ng-container *ngIf="displayContent ==='user-list'">
    <div>
      <p style="color: red;">No data to Display!</p>
    </div>
</ng-container>

<ng-container *ngIf="displayContent === 'add-user'">
  <div class="form-container">
      <h3>User Info</h3>
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
              <mat-form-field>
                  <mat-label>Email</mat-label>
                  <input matInput type="text" formControlName="userEmail" placeholder="Email">
                </mat-form-field>
          </div>
          <div class="form-group">
              <mat-form-field>
                  <mat-label>First Name</mat-label>
                  <input matInput type="text" formControlName="userFirstname" placeholder="First Name">
                </mat-form-field>
          </div>
          <div class="form-group">
              <mat-form-field>
                  <mat-label>Last Name</mat-label>
                  <input matInput type="text" formControlName="userLastname" placeholder="Last Name">
                </mat-form-field>
          </div>
          <div class="form-group">
              <mat-form-field>
                  <mat-label>Mobile</mat-label>
                  <input matInput type="text" formControlName="userMobile" placeholder="Mobile Number">
                </mat-form-field>
          </div>
          <div class="form-group">
              <mat-form-field>
                  <mat-label>Username</mat-label>
                  <input matInput type="text" formControlName="userUsername" placeholder="Username">
                </mat-form-field>
          </div>
          <div class="form-group">
              <mat-form-field>
                  <mat-label>Assign Role</mat-label>
                  <select matNativeControl formControlName="newRole" required>
                    <option value="role1">role1</option>
                    <option value="role2">role2</option>
                    <option value="role3">role3</option>
                    <option value="role4">role4</option>
                  </select>
                </mat-form-field>
          </div>
          <button type="submit" [disabled]="!userForm.valid" class="btn btn-primary">Submit</button>
      </form>
  </div>
</ng-container>

